export const environment = {
  production: true,
  API: "http://gis-mob-backend.demo.svc.cluster.local:8080/appgis/",
  RESOURCES: {
    CONFIG: "public/config",
    FEATURES: "public/getFeatures",
    ADD_IMAGE: "public/image/addImage",
    LOGIN: "public/auth/login",
    REFRESH: "public/auth/refresh",
    SIGNATURES: "private/signature",
    GET_MAP_PROVIDER_AUTH: "public/getMapProviderAuth"
  }
};



// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/environments/environment.ts